import { getCookie } from "./cookies";

/**
 * Checks if warning should show based on shipping address OR CF region
 * Priority: Shipping address first (where product is delivered), then CF region fallback
 */
export const shouldShowProp65 = (shippingState?: string | null): boolean => {
  // SSR check - return false on server
  if (typeof window === "undefined") return false;

  const country = getCookie("CF_COUNTRY") || "";
  const region = getCookie("CF_REGION") || "";

  // Priority 1: Use shipping address if available (Prop65 applies where product is delivered)
  if (shippingState) {
    return shippingState === "CA";
  }

  // Priority 2: Use CF region if available and country is US
  if (country === "US" && region) {
    return region === "CA";
  }

  // Fallback: Show for all US visitors if no region data available (compliance failsafe)
  return country === "US" && !region;
};
